export default "__VITE_ASSET__6AREhHK1__"